export default __webpack_public_path__ + "static/media/eds.354cf9cd.svg";